<template>
  <div class="pa-0 d-flex flex-wrap fill-width justify-space-around">
    <GoBack class="shrink pr-3" />
    <div v-if="!!contract.property" class="grow pt-3">
      <h2>
        {{
          "Contrato Nº" +
            contract.id +
            " - " +
            contract.property.address.street +
            " " +
            contract.property.address.number +
            (contract.property.address.unit
              ? " " + contract.property.address.unit
              : "") +
            ", " +
            contract.property.address.city +
            ", " +
            contract.property.address.state
        }}
      </h2>
      <p class="body-1 grey--text pt-0">
        {{
          $t("property.type." + contract.property.propertyType) +
            " | " +
            $t("contract.show.headers.owners", {
              name: contract.owner.map(x => x.profile.name).join(", ")
            }) +
            " | " +
            $t("contract.show.headers.tenant", {
              name: contract.tenant[0].profile.name
            })
        }}
      </p>
    </div>
    <div class="d-flex justify-end align-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="primary" v-bind="attrs" v-on="on">
            <v-icon large>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            :to="{ name: 'EditContract', params: { id: contract.id } }"
          >
            <v-list-item-title>Editar</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'Tickets', params: { id: contract.id } }">
            <v-list-item-title>Incidencias</v-list-item-title>
          </v-list-item>

          <v-list-item @click="open = true">
            <v-list-item-title>Rescindir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <finish
        :open="open"
        :key="count"
        :contract="contract"
        ref="finish"
      ></finish>
    </div>
  </div>
</template>

<script>
import GoBack from "@/components/GoBack.vue";
import Finish from "@/components/contracts/finish/Finish.vue";

export default {
  name: "ShowHeader",

  data: () => ({
    loading: false,
    open: false,
    count: 0
  }),

  components: {
    GoBack,
    Finish
  },

  props: ["contract"],

  methods: {
    openRescission() {
      this.count += 1;
      this.open = true;
    }
  }
};
</script>
